import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import CommunityPage from './pages/CommunityPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import OfferingsPage from './pages/OfferingsPage';
import SpeakToDoctorPage from './pages/SpeakToDoctorPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-cream" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/shop" element={<ShopPage data-id="element-8" />} data-id="element-7" />
            <Route path="/product/:id" element={<Navigate to="/shop" replace data-id="element-10" />} data-id="element-9" />
            <Route path="/about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
            <Route path="/blog" element={<BlogPage data-id="element-14" />} data-id="element-13" />
            <Route path="/blog/:id" element={<BlogPostPage data-id="element-16" />} data-id="element-15" />
            <Route path="/community" element={<CommunityPage data-id="element-18" />} data-id="element-17" />
            <Route path="/offerings" element={<OfferingsPage data-id="element-20" />} data-id="element-19" />
            <Route path="/doctor" element={<SpeakToDoctorPage data-id="element-22" />} data-id="element-21" />
            <Route path="/contact" element={<ContactPage data-id="element-24" />} data-id="element-23" />
            <Route path="/faq" element={<FAQPage data-id="element-26" />} data-id="element-25" />
          </Routes>
        </main>
        <Footer data-id="element-27" />
      </div>
    </Router>;
}